export default "__VITE_ASSET__b6885dd6__"